import React from 'react';
import SideBarMerchantComponent from './side-bar-merchant.component';

function SideBarMerchant(props) {
    return <SideBarMerchantComponent {...props} />;
}

export default SideBarMerchant;
